import { useQuery } from "@tanstack/react-query";
import { getTradingAccountsOptions } from "@/api/cashier/@tanstack/react-query.gen";
import { useMemo } from "react";

export const useTradingAccounts = () => {
  const {
    data: accountsData,
    isError,
    error,
    isLoading,
  } = useQuery({
    ...getTradingAccountsOptions({}),
  });

  const tradingAccounts = useMemo(() => {
    if (!accountsData) return [];
    return accountsData.accounts;
  }, [accountsData]);

  return {
    isError,
    error,
    isLoading,
    tradingAccounts,
  };
};
